import styled from 'styled-components/macro';

export default styled('div')`
  color: ${(props) => props.theme.input.helpTextColor};
  font-size: ${(props) => props.theme.input.helpTextFontSize};
  margin: 5px 0;
`;
